<template>
    <div>
        <iframe @load="iframeIsLoaded" class="banner" id="theiframe" src="https://www.itender.am/assets/banner/" height="100%" width="100%" title="Iframe Example"></iframe>
    </div>
</template>

<script>
    export default {
        name: 'VtbBanner',
        data(){
            return{
                serverUrl: process.env.VUE_URL,
                key: 0,
            }
        },
        watch: {
            key (value) {
                const _this = this
                document.getElementById("theiframe").contentWindow.document.getElementById("vtb_banner").addEventListener("click", function(){
                    _this.sendRequest()
                });
            }
        },
        methods: {
            iframeIsLoaded () {
                this.key = this.key + 1;
            },
            sendRequest () {
                this.$client.post('banner/click')
            },
        }
    }
</script>
<style>
.banner{
    width: 405px;
    height: 305px;
}
</style>
